import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import { AuthProvider } from './lib/auth.jsx'
import './styles/globals.css'
import './styles/tailwind.css'
import '@patienttrac/clinical-viewer/styles.css'

const queryClient = new QueryClient()

// Detect cross-app bridge mode (launched from PatientTracForge with ?token=)
const params = new URLSearchParams(window.location.search)
const isBridgeMode = params.has('token') && params.has('encounter_id')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App isBridgeMode={isBridgeMode} />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
